import { Alert } from '../popupAlerts';
import {
  getUploadedFiles,
  deleteUploadedFiles,
  uploadFiles,
  discoverLinkedSourceCatalog,
  generatePresignedUploadUrl,
} from '../../api/client';
import { getSelectedEntity, getSelectedSource } from '../../redux/selectors';
import * as UIAction from '../../redux/actions/ui.actions';

export const loadUploadedFiles = async (self) => {
  self.setState({ isUpdating: true });

  try {
    const r = await getUploadedFiles();
    self.setState({ uploadedFiles: r });
  } finally {
    self.setState({ isUpdating: false });
  }
};

const detectFileType = (file) => {
  const extension = file.name.split('.').pop()?.toLowerCase();
  
  // Simple extension to MIME type mapping for common files
  const mimeTypes = {
    'csv': 'text/csv',
    'json': 'application/json',
    'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'xls': 'application/vnd.ms-excel',
    'pdf': 'application/pdf',
    'txt': 'text/plain',
    'zip': 'application/zip',
    'parquet': 'application/octet-stream'
  };

  return mimeTypes[extension] || extension || 'application/octet-stream';
};

export const onSubmit = async (self) => {
  const { files } = self.state;
  const entity = getSelectedEntity();

  self.setState({ isUpdating: true });

  try {
    for (const file of files) {
      const fileName = file.name;
      const fileType = file.type || detectFileType(file);
      const entityType =
        entity.entityType === 'source' ? 'taps' : entity.entityType === 'connector' ? 'connectors' : 'targets';

      
      
      if(!file.type && !fileType) {
        Alert({ text: `File type not supported: ${fileName}`, type: 'error' });
        return;
      }

      const { upload_presigned_url } = await generatePresignedUploadUrl(fileName, fileType, entityType);
      
      const fileToUpload = !file.type && fileType ? new File([file], fileName, { type: fileType }) : file;
      await fetch(upload_presigned_url, {
        method: 'PUT',
        body: fileToUpload,
      });
    }
  } catch (err) {
    Alert({ text: `Something went wrong in the upload ${err}`, type: 'error' });
    self.setState({ isUpdating: false });
    return;
  }

  Alert({ text: "You're all set! Your files were uploaded and are ready to be imported.", type: 'success' });

  self.setState({ isUpdating: false, files: [], uploadedFiles: [] });
  loadUploadedFiles(self);

  discoverLinkedSourceCatalog('file');
};

export const handleRemoteClear = (self) => {
  // TODO: Replace this
  self.setState({ ...self.state, isUpdating: true });
  deleteUploadedFiles()
    .then(() => {
      self.setState({ ...self.state, isUpdating: false, uploadedFiles: [], confirmingDelete: false });
    })
    .catch((err) => {
      console.error('Failed to delete remote files', err);
      Alert({ text: `Failed to clear files: ${err}`, type: 'error' });
      self.setState({ ...self.state, isUpdating: false, uploadedFiles: [] });
    });
};
